(function () {
  const initPartialCourseCombinationSelection = function (
    $partialCourseCombinationSelection
  ) {
    const $form = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__form'
      ),
      $schoolTypeSelect = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__school-type select'
      ),
      $partialCourse1Select = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__partial-course-1 select'
      ),
      $partialCourse2Select = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__partial-course-2 select'
      ),
      $schoolTypeOptions = $schoolTypeSelect.querySelectorAll('option'),
      $partialCourse1Options = $partialCourse1Select.querySelectorAll('option'),
      $partialCourse2Options = $partialCourse2Select.querySelectorAll('option'),
      $masterCourseItems = $partialCourseCombinationSelection.querySelectorAll(
        '.partial-course-combination-selection__master-course-item'
      ),
      $bachelorCourseItems =
        $partialCourseCombinationSelection.querySelectorAll(
          '.partial-course-combination-selection__bachelor-course-item'
        ),
      $partialCourseItems = $partialCourseCombinationSelection.querySelectorAll(
        '.partial-course-combination-selection__partial-course-item'
      ),
      $note = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__note'
      ),
      $shareButton = $partialCourseCombinationSelection.querySelector(
        '.partial-course-combination-selection__share-button'
      ),
      partialCourseCombinations = JSON.parse(
        $partialCourseCombinationSelection.dataset.partialCourseCombinations
      ),
      id = $partialCourseCombinationSelection.id,
      queryParameters = new URLSearchParams(window.location.search);

    let selectedSchoolTypeValue = getOptionValueByEnabledLabel(
        $schoolTypeSelect,
        queryParameters.get('schoolType')
      ),
      selectedPartialCourse1Value = getOptionValueByEnabledLabel(
        $partialCourse1Select,
        queryParameters.get('partialCourse1')
      ),
      selectedPartialCourse2Value = getOptionValueByEnabledLabel(
        $partialCourse2Select,
        queryParameters.get('partialCourse2')
      ),
      initializing = true;

    $form.addEventListener('reset', function () {
      // Manually trigger input changes after form reset, so UI will be updated
      setTimeout(function () {
        $schoolTypeSelect.dispatchEvent(new Event('change'));
        $partialCourse1Select.dispatchEvent(new Event('change'));
        $partialCourse2Select.dispatchEvent(new Event('change'));
      }, 0);
    });

    $shareButton.addEventListener('click', function (event) {
      sendTrackingEvent('Share', 'URL', event.currentTarget.href);
    });

    $schoolTypeSelect.addEventListener('change', function () {
      selectedSchoolTypeValue = this.value;
      updateUrl(
        $schoolTypeSelect,
        $partialCourse1Select,
        $partialCourse2Select
      );
      updateSharebutton($shareButton, id);
      updateBachelorCourseItems($bachelorCourseItems, selectedSchoolTypeValue);
      updateMasterCourseItems($masterCourseItems, selectedSchoolTypeValue);
      updateSchoolTypeOptions(
        $schoolTypeOptions,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse1Options(
        $partialCourse1Options,
        selectedSchoolTypeValue,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse2Options(
        $partialCourse2Options,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        partialCourseCombinations
      );
      updateNote(
        $note,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      if (!initializing) {
        sendTrackingEvent(
          'Select',
          'School type',
          this.options[this.selectedIndex].dataset.enabledLabel
        );
      }
    });

    $partialCourse1Select.addEventListener('change', function () {
      selectedPartialCourse1Value = this.value;
      updateUrl(
        $schoolTypeSelect,
        $partialCourse1Select,
        $partialCourse2Select
      );
      updateSharebutton($shareButton, id);
      updatePartialCourseItems(
        $partialCourseItems,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value
      );
      updateSchoolTypeOptions(
        $schoolTypeOptions,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse1Options(
        $partialCourse1Options,
        selectedSchoolTypeValue,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse2Options(
        $partialCourse2Options,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        partialCourseCombinations
      );
      updateNote(
        $note,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      if (!initializing) {
        sendTrackingEvent(
          'Select',
          'Partial Course 1',
          this.options[this.selectedIndex].dataset.enabledLabel
        );
      }
    });

    $partialCourse2Select.addEventListener('change', function () {
      selectedPartialCourse2Value = this.value;
      updateUrl(
        $schoolTypeSelect,
        $partialCourse1Select,
        $partialCourse2Select
      );
      updateSharebutton($shareButton, id);
      updatePartialCourseItems(
        $partialCourseItems,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value
      );
      updateSchoolTypeOptions(
        $schoolTypeOptions,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse1Options(
        $partialCourse1Options,
        selectedSchoolTypeValue,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      updatePartialCourse2Options(
        $partialCourse2Options,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        partialCourseCombinations
      );
      updateNote(
        $note,
        selectedSchoolTypeValue,
        selectedPartialCourse1Value,
        selectedPartialCourse2Value,
        partialCourseCombinations
      );
      if (!initializing) {
        sendTrackingEvent(
          'Select',
          'Partial Course 2',
          this.options[this.selectedIndex].dataset.enabledLabel
        );
      }
    });

    if (selectedSchoolTypeValue) {
      $schoolTypeSelect.value = selectedSchoolTypeValue;
    }
    if (selectedPartialCourse1Value) {
      $partialCourse1Select.value = selectedPartialCourse1Value;
    }
    if (selectedPartialCourse2Value) {
      $partialCourse2Select.value = selectedPartialCourse2Value;
    }
    if (selectedSchoolTypeValue) {
      $schoolTypeSelect.dispatchEvent(new Event('change'));
    }
    if (selectedPartialCourse1Value) {
      $partialCourse1Select.dispatchEvent(new Event('change'));
    }
    if (selectedPartialCourse2Value) {
      $partialCourse2Select.dispatchEvent(new Event('change'));
    }

    initializing = false;
  };

  const updateUrl = function (
    $schoolTypeSelect,
    $partialCourse1Select,
    $partialCourse2Select
  ) {
    const url = new URL(window.location);
    const getEnabledLabel = function ($select) {
      return $select.options[$select.selectedIndex].dataset.enabledLabel;
    };

    url.searchParams.delete('schoolType');
    url.searchParams.delete('partialCourse1');
    url.searchParams.delete('partialCourse2');

    if (getEnabledLabel($schoolTypeSelect)) {
      url.searchParams.set('schoolType', getEnabledLabel($schoolTypeSelect));
    }

    // Normalize the two partial courses so a combination has a single URL.
    const partialCourses = [
      getEnabledLabel($partialCourse1Select),
      getEnabledLabel($partialCourse2Select),
    ]
      .filter(Boolean)
      .sort(function (partialCourseA, partialCourseB) {
        return partialCourseA.localeCompare(partialCourseB);
      });
    partialCourses.forEach(function (partialCourse, index) {
      url.searchParams.set('partialCourse' + (index + 1), partialCourse);
    });

    url.searchParams.sort();
    window.history.pushState({}, '', url);
  };

  const updateSharebutton = function ($shareButton, hash) {
    const url = new URL(window.location);
    const queryParameters = new URLSearchParams();

    ['schoolType', 'partialCourse1', 'partialCourse2'].forEach(
      function (queryParameterKey) {
        const queryParameterValue = url.searchParams.get(queryParameterKey);
        if (queryParameterValue !== null) {
          queryParameters.set(queryParameterKey, queryParameterValue);
        }
      }
    );

    queryParameters.set('mtm_campaign', 'Baukasten Sharing');
    queryParameters.sort();
    url.search = queryParameters.toString();
    url.hash = hash;
    $shareButton.href = url;
  };

  const updateMasterCourseItems = function (
    $masterCourseItems,
    selectedSchoolTypeValue
  ) {
    $masterCourseItems.forEach(function ($masterCourseItem) {
      $masterCourseItem.classList.add(
        'partial-course-combination-selection__master-course-item--hidden'
      );

      if (
        parseInt($masterCourseItem.dataset.schoolType) ===
        parseInt(selectedSchoolTypeValue)
      ) {
        $masterCourseItem.classList.remove(
          'partial-course-combination-selection__master-course-item--hidden'
        );
      }
    });
  };

  const updateBachelorCourseItems = function (
    $bachelorCourseItems,
    selectedSchoolTypeValue
  ) {
    $bachelorCourseItems.forEach(function ($bachelorCourseItem) {
      $bachelorCourseItem.classList.add(
        'partial-course-combination-selection__bachelor-course-item--hidden'
      );

      if (
        parseInt($bachelorCourseItem.dataset.schoolType) ===
        parseInt(selectedSchoolTypeValue)
      ) {
        $bachelorCourseItem.classList.remove(
          'partial-course-combination-selection__bachelor-course-item--hidden'
        );
      }
    });
  };

  const updatePartialCourseItems = function (
    $partialCourseItems,
    selectedPartialCourse1Value,
    selectedPartialCourse2Value
  ) {
    $partialCourseItems.forEach(function ($partialCourseItem) {
      $partialCourseItem.classList.add(
        'partial-course-combination-selection__partial-course-item--hidden'
      );

      if (
        parseInt($partialCourseItem.dataset.partialCourse) ===
        parseInt(selectedPartialCourse1Value)
      ) {
        $partialCourseItem.classList.remove(
          'partial-course-combination-selection__partial-course-item--hidden'
        );
      }
      if (
        parseInt($partialCourseItem.dataset.partialCourse) ===
        parseInt(selectedPartialCourse2Value)
      ) {
        $partialCourseItem.classList.remove(
          'partial-course-combination-selection__partial-course-item--hidden'
        );
      }
    });
  };

  const updateSchoolTypeOptions = function (
    $schoolTypeOptions,
    selectedPartialCourse1Value,
    selectedPartialCourse2Value,
    partialCourseCombinations
  ) {
    $schoolTypeOptions.forEach(function ($schoolTypeOption) {
      disableOption($schoolTypeOption);

      // Always enable empty option
      if ($schoolTypeOption.value === '') {
        enableOption($schoolTypeOption);
        return;
      }

      partialCourseCombinations.forEach(function (partialCourseCombination) {
        // [X] Partial course 1
        // [X] Partial course 2
        if (
          !isNaN(parseInt(selectedPartialCourse1Value)) &&
          !isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt($schoolTypeOption.value) ===
            parseInt(partialCourseCombination.schoolType)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt(selectedPartialCourse1Value) &&
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt(selectedPartialCourse2Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt(selectedPartialCourse1Value) &&
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt(selectedPartialCourse2Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
          }
        }

        // [X] Partial course 1
        // [ ] Partial course 2
        if (
          !isNaN(parseInt(selectedPartialCourse1Value)) &&
          isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt($schoolTypeOption.value) ===
            parseInt(partialCourseCombination.schoolType)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
              parseInt(selectedPartialCourse1Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
              parseInt(selectedPartialCourse1Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
          }
        }

        // [ ] Partial course 1
        // [X] Partial course 2
        if (
          isNaN(parseInt(selectedPartialCourse1Value)) &&
          !isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt($schoolTypeOption.value) ===
            parseInt(partialCourseCombination.schoolType)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
              parseInt(selectedPartialCourse2Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
              parseInt(selectedPartialCourse2Value)
            ) {
              enableOption($schoolTypeOption);
              return;
            }
          }
        }

        // [ ] Partial course 1
        // [ ] Partial course 2
        if (
          isNaN(parseInt(selectedPartialCourse1Value)) &&
          isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          enableOption($schoolTypeOption);
          return;
        }
      });
    });

    orderOptions($schoolTypeOptions);
  };

  const updatePartialCourse1Options = function (
    $partialCourse1Options,
    selectedSchoolTypeValue,
    selectedPartialCourse2Value,
    partialCourseCombinations
  ) {
    $partialCourse1Options.forEach(function ($partialCourse1Option) {
      disableOption($partialCourse1Option);

      // Always enable empty option
      if ($partialCourse1Option.value === '') {
        enableOption($partialCourse1Option);
        return;
      }

      partialCourseCombinations.forEach(function (partialCourseCombination) {
        // [X] School type
        // [X] Partial course 2
        if (
          !isNaN(parseInt(selectedSchoolTypeValue)) &&
          !isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt(partialCourseCombination.schoolType) ===
            parseInt(selectedSchoolTypeValue)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt(selectedPartialCourse2Value) &&
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt($partialCourse1Option.value)
            ) {
              enableOption($partialCourse1Option);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt(selectedPartialCourse2Value) &&
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt($partialCourse1Option.value)
            ) {
              enableOption($partialCourse1Option);
              return;
            }
          }
        }

        // [X] School type
        // [ ] Partial course 2
        if (
          !isNaN(parseInt(selectedSchoolTypeValue)) &&
          isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt(partialCourseCombination.schoolType) ===
            parseInt(selectedSchoolTypeValue)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
              parseInt($partialCourse1Option.value)
            ) {
              enableOption($partialCourse1Option);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
              parseInt($partialCourse1Option.value)
            ) {
              enableOption($partialCourse1Option);
              return;
            }
          }
        }

        // [ ] School type
        // [X] Partial course 2
        if (
          isNaN(parseInt(selectedSchoolTypeValue)) &&
          !isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          if (
            parseInt(partialCourseCombination.partialCourse1) ===
              parseInt(selectedPartialCourse2Value) &&
            parseInt(partialCourseCombination.partialCourse2) ===
              parseInt($partialCourse1Option.value)
          ) {
            enableOption($partialCourse1Option);
            return;
          }
          if (
            parseInt(partialCourseCombination.partialCourse2) ===
              parseInt(selectedPartialCourse2Value) &&
            parseInt(partialCourseCombination.partialCourse1) ===
              parseInt($partialCourse1Option.value)
          ) {
            enableOption($partialCourse1Option);
            return;
          }
        }

        // [ ] School type
        // [ ] Partial course 2
        if (
          isNaN(parseInt(selectedSchoolTypeValue)) &&
          isNaN(parseInt(selectedPartialCourse2Value))
        ) {
          enableOption($partialCourse1Option);
          return;
        }
      });
    });

    orderOptions($partialCourse1Options);
  };

  const updatePartialCourse2Options = function (
    $partialCourse2Options,
    selectedSchoolTypeValue,
    selectedPartialCourse1Value,
    partialCourseCombinations
  ) {
    $partialCourse2Options.forEach(function ($partialCourse2Option) {
      disableOption($partialCourse2Option);

      // Always enable empty option
      if ($partialCourse2Option.value === '') {
        enableOption($partialCourse2Option);
        return;
      }

      partialCourseCombinations.forEach(function (partialCourseCombination) {
        // [X] School type
        // [X] Partial course 1
        if (
          !isNaN(parseInt(selectedSchoolTypeValue)) &&
          !isNaN(parseInt(selectedPartialCourse1Value))
        ) {
          if (
            parseInt(partialCourseCombination.schoolType) ===
            parseInt(selectedSchoolTypeValue)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt(selectedPartialCourse1Value) &&
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt($partialCourse2Option.value)
            ) {
              enableOption($partialCourse2Option);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
                parseInt(selectedPartialCourse1Value) &&
              parseInt(partialCourseCombination.partialCourse1) ===
                parseInt($partialCourse2Option.value)
            ) {
              enableOption($partialCourse2Option);
              return;
            }
          }
        }

        // [X] School type
        // [ ] Partial course 1
        if (
          !isNaN(parseInt(selectedSchoolTypeValue)) &&
          isNaN(parseInt(selectedPartialCourse1Value))
        ) {
          if (
            parseInt(partialCourseCombination.schoolType) ===
            parseInt(selectedSchoolTypeValue)
          ) {
            if (
              parseInt(partialCourseCombination.partialCourse2) ===
              parseInt($partialCourse2Option.value)
            ) {
              enableOption($partialCourse2Option);
              return;
            }
            if (
              parseInt(partialCourseCombination.partialCourse1) ===
              parseInt($partialCourse2Option.value)
            ) {
              enableOption($partialCourse2Option);
              return;
            }
          }
        }

        // [ ] School type
        // [X] Partial course 1
        if (
          isNaN(parseInt(selectedSchoolTypeValue)) &&
          !isNaN(parseInt(selectedPartialCourse1Value))
        ) {
          if (
            parseInt(partialCourseCombination.partialCourse1) ===
              parseInt(selectedPartialCourse1Value) &&
            parseInt(partialCourseCombination.partialCourse2) ===
              parseInt($partialCourse2Option.value)
          ) {
            enableOption($partialCourse2Option);
            return;
          }
          if (
            parseInt(partialCourseCombination.partialCourse2) ===
              parseInt(selectedPartialCourse1Value) &&
            parseInt(partialCourseCombination.partialCourse1) ===
              parseInt($partialCourse2Option.value)
          ) {
            enableOption($partialCourse2Option);
            return;
          }
        }

        // [ ] School type
        // [ ] Partial course 1
        if (
          isNaN(parseInt(selectedSchoolTypeValue)) &&
          isNaN(parseInt(selectedPartialCourse1Value))
        ) {
          enableOption($partialCourse2Option);
          return;
        }
      });
    });

    orderOptions($partialCourse2Options);
  };

  const updateNote = function (
    $note,
    selectedSchoolTypeValue,
    selectedPartialCourse1Value,
    selectedPartialCourse2Value,
    partialCourseCombinations
  ) {
    let note = '';
    partialCourseCombinations.forEach(function (partialCourseCombination) {
      if (
        parseInt(partialCourseCombination.schoolType) ===
        parseInt(selectedSchoolTypeValue)
      ) {
        if (
          parseInt(partialCourseCombination.partialCourse1) ===
            parseInt(selectedPartialCourse1Value) &&
          parseInt(partialCourseCombination.partialCourse2) ===
            parseInt(selectedPartialCourse2Value)
        ) {
          note = partialCourseCombination.note;
          return;
        }
        if (
          parseInt(partialCourseCombination.partialCourse1) ===
            parseInt(selectedPartialCourse2Value) &&
          parseInt(partialCourseCombination.partialCourse2) ===
            parseInt(selectedPartialCourse1Value)
        ) {
          note = partialCourseCombination.note;
          return;
        }
      }
    });

    $note.innerHTML =
      note !== ''
        ? '<strong>' + $note.dataset.label + ':</strong> ' + note
        : '';
  };

  const disableOption = function ($option) {
    $option.disabled = true;

    if ($option.dataset.disabledTitle !== undefined) {
      $option.title = $option.dataset.disabledTitle;
    }

    if ($option.dataset.disabledLabel !== undefined) {
      $option.innerHTML = $option.dataset.disabledLabel;
    }
  };

  const enableOption = function ($option) {
    $option.disabled = false;

    $option.title = '';

    if ($option.dataset.enabledLabel !== undefined) {
      $option.innerHTML = $option.dataset.enabledLabel;
    }
  };

  // Order options by disabled / enabled state
  // and original order (defined in data attribute)
  const orderOptions = function ($options) {
    Array.from($options)
      .sort(function (optionA, optionB) {
        const aOrder = parseInt(optionA.dataset.originalOrder);
        const bOrder = parseInt(optionB.dataset.originalOrder);

        if (optionA.disabled && !optionB.disabled) {
          return 1;
        }
        if (!optionA.disabled && optionB.disabled) {
          return -1;
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      })
      .forEach(function ($option) {
        $option.parentNode.appendChild($option);
      });
  };

  const getOptionValueByEnabledLabel = function ($select, enabledLabel) {
    if (!enabledLabel) {
      return null;
    }

    const $option = Array.from($select.options).find(function ($option) {
      return $option.dataset.enabledLabel === enabledLabel;
    });

    return $option ? $option.value : null;
  };

  const sendTrackingEvent = function (action, key, value) {
    if (typeof _paq === 'undefined') {
      return;
    }

    _paq.push([
      'trackEvent',
      'Partial Course Combination Selection',
      action,
      key,
      value,
    ]);
  };

  const $partialCourseCombinationSelections = document.querySelectorAll(
    '.partial-course-combination-selection'
  );

  $partialCourseCombinationSelections.forEach(
    function ($partialCourseCombinationSelection) {
      initPartialCourseCombinationSelection($partialCourseCombinationSelection);
    }
  );
})();
